@if (url$ | async; as url) {
  <div class="iframe-container">
    <iframe
      id="pdf-preview-iframe"
      [src]="IFrameUrl(url)"
      frameborder="0"
    ></iframe>
  </div>
}
